export const devMode = window.location.hostname === 'localhost' || window.location.hostname === 'crm.optictoria';
export const mainUrl = window.location.hostname === 'crm.optictoria.ru' ? 'https://crm.optictoria.ru' : 'https://crm.dev.optictoria.ru';
export const mainUrlOrigin = window.location.origin;
export const homepage = devMode ? '/' : '/'
export const mainUrlRequest = mainUrl + '/api/?' + (devMode ? 'dev=Y' : '');
